'use strict';

module Patersons {

    export class ActionButtonComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/common/components/actionButton.component.html';
        bindings: any = {
            isDisabled: '<',
            isBusy: '<',
            text: '@',
            onClick: '&'
        };
    }
}